module.exports = __webpack_public_path__ + "static/img/support.3dea406a.png";